// src/api/journalImportFnct.api.ts — SCE Issues
// Le journal d'un import de la base FNC-T (lot 8 du § 14, 22/10) : un fichier
// JSON par import dans la bibliothèque SCE_PiecesJointes, dossier
// `_SCE Issues/Imports FNC-T/`, jamais écrasé (« rename » si le nom existe). C'est
// la trace pour un audit : ce qui a été lu, signalé, écrit, et le résultat de la
// vérification aller-retour. Graph crée le dossier au premier dépôt.

import { graphFetch } from './graphClient'
import { nomJournal, type JournalImportFnct } from '@/utils/controleImportFnct'
import { nomSauvegarde, type SauvegardeFnct } from '@/utils/vidageFnct'

const DRIVE_ID = import.meta.env.VITE_DRIVE_PIECES_JOINTES_ID ?? ''
export const DOSSIER_JOURNAUX_FNCT = '_SCE Issues/Imports FNC-T'

/**
 * Dépose la copie des listes avant un vidage (26/10), à côté des journaux ;
 * renvoie son chemin. Un échec lève : on ne vide jamais sans copie.
 */
export async function deposerSauvegardeFnct(sauvegarde: SauvegardeFnct): Promise<string> {
  const chemin = `${DOSSIER_JOURNAUX_FNCT}/${nomSauvegarde(new Date(sauvegarde.le))}`
  const adresse = `/drives/${DRIVE_ID}/root:/${chemin.split('/').map(encodeURIComponent).join('/')}:/content?@microsoft.graph.conflictBehavior=rename`
  await graphFetch(adresse, {
    method: 'PUT',
    rawBody: new TextEncoder().encode(JSON.stringify(sauvegarde, null, 2)),
    headers: { 'Content-Type': 'application/json' },
  })
  return chemin
}

/** Dépose le journal ; renvoie le chemin du fichier dans la bibliothèque. */
export async function deposerJournalImportFnct(journal: JournalImportFnct): Promise<string> {
  const chemin = `${DOSSIER_JOURNAUX_FNCT}/${nomJournal(new Date(journal.le))}`
  const adresse = `/drives/${DRIVE_ID}/root:/${chemin.split('/').map(encodeURIComponent).join('/')}:/content?@microsoft.graph.conflictBehavior=rename`
  await graphFetch(adresse, {
    method: 'PUT',
    rawBody: new TextEncoder().encode(JSON.stringify(journal, null, 2)),
    headers: { 'Content-Type': 'application/json' },
  })
  return chemin
}
